/**
 * Analytics service for Google Analytics integration
 * Handles loading GA script, tracking page views, and respecting user consent
 */

// Google Analytics Measurement ID
const GA_MEASUREMENT_ID = 'G-EECV23TNQP';

/**
 * Initialize Google Analytics
 * Only loads the script if user has given consent
 * @returns {boolean} Whether GA was initialized
 */
export const initializeGA = () => {
  const consentStatus = localStorage.getItem('cookieConsent');
  
  // Only initialize if user has accepted cookies
  if (consentStatus === 'accepted') {
    // Create script elements for Google Analytics
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}', { 'anonymize_ip': true });
    `;
    
    // Add scripts to document
    document.head.appendChild(gtagScript);
    document.head.appendChild(inlineScript);
    
    return true;
  }
  
  return false;
};

/**
 * Track a page view in Google Analytics
 * @param {string} path - The current page path
 * @param {string} title - The page title
 */
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  }
};

/**
 * Track an event in Google Analytics
 * @param {string} action - The event action
 * @param {Object} params - Additional event parameters
 */
export const trackEvent = (action, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, params);
  }
};

/**
 * Remove Google Analytics scripts from the page
 * Used when user revokes consent
 */
export const removeGA = () => {
  // Remove GA scripts
  const scripts = document.querySelectorAll(`script[src*="googletagmanager.com"]`);
  scripts.forEach(script => script.remove());
  
  // Remove inline scripts (more difficult to target specifically)
  const inlineScripts = document.querySelectorAll('script');
  inlineScripts.forEach(script => {
    if (script.innerHTML.includes('gtag') && script.innerHTML.includes(GA_MEASUREMENT_ID)) {
      script.remove();
    }
  });
  
  // Remove cookies
  document.cookie = '_ga=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = '_ga_' + GA_MEASUREMENT_ID.replace('G-', '') + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = '_gid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = '_gat=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
